/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";

export default function CustomersHead({ setFilter, setCurrentPage }) {
	//const [activeItem, setActiveItem] = useState("All vehicles");
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const statusOptions = [
		{ label: trans("Active"), value: true },
		{ label: trans("Inactive"), value: false },
	];
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
				<InputSelect
					placeholder={trans("Status")}
					options={statusOptions}
					formstyle="w-25 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, status: e }));
						setCurrentPage(1);
					}}
				/>
			</div>
		</>
	);
}
